import { render } from "./EditObat.vue?vue&type=template&id=612ed4b4"
import script from "./EditObat.vue?vue&type=script&lang=js"
export * from "./EditObat.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__